import React, { useEffect } from 'react'
import { useStateValue } from '../../StateProvider';
import Item from './Item';
import amazone from '../../assets/Amazone.png'
import whatsapp from '../../assets/Whatsapp.png'
import discord from '../../assets/Discord.png'
import facebook from '../../assets/Facebook.png'
import widetravel from '../../assets/Widetravel.png'
import Bank from '../../assets/Bank.png'
import tinder from '../../assets/Tinder.png'
import disney from '../../assets/disney.png'
import doctorApp from '../../assets/doctorApp.png'
import {useTranslation} from "react-i18next";
import './Portfolio.css'
import Certificat from './Certificat';

function Portfolio() {
    const PortfolioContainer = React.createRef();
    const [state, dispatch] = useStateValue();
    const {t, i18n} = useTranslation('common');
    useEffect(() => {
        dispatch({
            type : "ADD_REF",
            ref : PortfolioContainer.current.offsetTop
        })
    }, [])
    return (
        <div ref={PortfolioContainer} className="portfolio">
            <h1>Portfolio</h1>
            <div className="rowPortfolio">
                <Item 
                img ={disney}
                title="Disney Clone" 
                description={t('portfolio.p12')}
                linkweb="https://disney-clone-32d3d.firebaseapp.com/" 
                linkgithub="https://github.com/ouss1919/desniy-clone"
                tags="React.js;Firebase;Redux;StyledComponents"/>

            </div>
            <div className="rowPortfolio">
            <Item 
                img ={Bank}
                title="Bank Landing page" 
                description={t('portfolio.p11')}
                linkweb="https://banking-website-180a2.web.app/" 
                linkgithub="https://github.com/ouss1919/Banking-website"
                tags="React.js;Firebase;StyledComponents"/>
                <Item 
                img ={amazone}
                title="Amazone Clone" 
                description={t('portfolio.p1')}
                linkweb="https://e-clone-51802.firebaseapp.com/" 
                linkgithub="https://github.com/ouss1919/Amazone-clone"
                tags="React.js;Firebase"/>

            </div>
            <div className="rowPortfolio">
                            <Item 
                            img ={discord}
                            title="Discord Clone" 
                            description={t('portfolio.p3')} 
                            linkweb="https://discord-clone-bfbc2.firebaseapp.com/" 
                            linkgithub="https://github.com/ouss1919/discord-clone"
                            tags="React.js;Redux;Firebase"/>
                            <Item 
                            img ={facebook}
                            title="Facebook Clone" 
                            description={t('portfolio.p4')}
                            linkweb="https://fb-react-clone-1c10d.firebaseapp.com/" 
                            linkgithub="https://github.com/ouss1919/fb-clone"
                            tags="React.js;Firebase"/>
            </div>
            <div className="rowPortfolio">
                            <Item 
                            img ={tinder}
                            title="Tinder Clone" 
                            description={t('portfolio.p5')}
                            linkweb="https://tinder-26236.firebaseapp.com/" 
                            linkgithub="https://github.com/ouss1919/Tinder-clone"
                            tags="React.js;Firebase;Firebase_functions;Node.js;Express;MongoDb"/>
                            <Item 
                            img ={widetravel}
                            title="Wide Travel" 
                            description={t('portfolio.p6')} 
                            linkweb="https://wide-travel.vercel.app/" 
                            linkgithub="https://github.com/ouss1919/wide_travel"
                            tags="React.js"/>
            </div>
            <div className="rowPortfolio">
                        <Item 
                            img ={whatsapp}
                            title="Whatsapp Clone" 
                            description={t('portfolio.p2')}
                            linkweb="https://whatsup-clone-b89d0.web.app/" 
                            linkgithub="https://github.com/ouss1919/whatup-clone"
                            tags="React.js;Socket.io;Node.js;MongoDb;Express;Firebase, Heroku"/>
                            <Item 
                            img ={doctorApp}
                            title="Patient Doctor Manager" 
                            description={t('portfolio.p7')}
                            linkweb="https://drive.google.com/file/d/1oy9L9kpo5AEJxaGqEHa62Nhr7X5zPKD5/view" 
                            linkgithub="https://github.com/ouss1919/Doctors-patients-Android-App"
                            tags="Kotlin;Node.js;MySQL"/>
            </div>
            <h2>{t('portfolio.p10')}</h2>
            <div className="certifications">
                    <Certificat name="Spécialisation Python for Everybody"
                    university="University of Michigan"
                    organization="Coursera"
                    date="octobre 2020"
                    Id="N74KD9VH9VH2"
                    url="https://www.coursera.org/account/accomplishments/specialization/certificate/N74KD9VH9VH2"/>
                                <Certificat name="Introduction to Data Science in Python"
                    university="University of Michigan"
                    organization="Coursera"
                    date="août 2020"
                    Id="GCEPTTRZW5KZ"
                    url="https://www.coursera.org/account/accomplishments/certificate/GCEPTTRZW5KZ"/>
                                <Certificat name="Front-End Web UI Frameworks and Tools: Bootstrap 4"
                    university="The Hong Kong University of Science and Technology"
                    organization="Coursera"
                    date="août 2020"
                    Id="B3EAQQZBAFEG"
                    url="https://www.coursera.org/account/accomplishments/certificate/B3EAQQZBAFEG"/>
                                <Certificat name="Neural Networks and Deep Learning"
                    university="DeepLearning.AI"
                    organization="Coursera"
                    date="août 2020"
                    Id="S6SFX3R5F6HP"
                    url="https://www.coursera.org/account/accomplishments/certificate/S6SFX3R5F6HP"/>
                                <Certificat name="Web Application Technologies and Django"
                    university="University of Michigan"
                    organization="Coursera"
                    date="août 2020"
                    Id="32GQMDVYCR48"
                    url="https://www.coursera.org/account/accomplishments/certificate/32GQMDVYCR48"/>
            </div>
            
        </div>
    )
}

export default Portfolio
